import { render } from 'preact';
import NavigationWidgetImpl from './navigation-widget';

/**
 * @memberOf woosmap.map
 */
export default class NavigationWidget {
    _indoorRenderer: woosmap.map.IndoorRenderer;
    _container: HTMLElement;
    _closeCb: () => void;
    _selectedWaypoints: woosmap.map.GeoJSONFeature[] | null | undefined;
    _selectedDestination!: woosmap.map.GeoJSONFeature | null | undefined;

    /**
     * Creates a new Indoor Navigation Wiget.
     * @param [renderer] IndoorRenderer
     * @param [closeCb] Callback called when the widget is closed by the user.
     * @constructor
     */
    constructor(renderer: woosmap.map.IndoorRenderer, closeCb: () => void, selectedWaypoints?: woosmap.map.GeoJSONFeature[] | null | undefined, selectedDestination?: woosmap.map.GeoJSONFeature | null | undefined) {
        this._indoorRenderer = renderer;
        this._closeCb = closeCb;
        this._selectedWaypoints = selectedWaypoints;
        this._selectedDestination = selectedDestination;
        const container = (this._container = document.createElement('div'));
        container.classList.add('woosmap-navigation-panel');
        if ((this._indoorRenderer as any).map) {
            (this._indoorRenderer as any).map._container.classList.add('woosmap-navigation');
        }
    }

    /**
     * Sets the map where to render the Indoor navigation widget.
     * @param {?woosmap.map.Map} map
     */
    setMap(map: woosmap.map.Map): void {
        if (map) {
            const control = (map as any)._container.getElementsByClassName('mapboxgl-control-container')[0];
            if (control && this._container) {
                control.prepend(this._container);
            }
            this._renderPanel();
        } else {
            this.onRemove();
        }
    }

    onRemove() {
        if (this._container && this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
            render(null, this._container);
            if ((this._indoorRenderer as any).map) {
                (this._indoorRenderer as any).map._container.classList.remove('woosmap-navigation');
            }
            (this._indoorRenderer as any)._directionsRenderer.resetDirections();
            this._indoorRenderer.highlightStep(null);
            this._indoorRenderer.resetUserMarker();
        }
    }

    _renderPanel() {
        render(
            <NavigationWidgetImpl
                controller={this}
                directions={(this._indoorRenderer as any).getDirections()}
                highlightStep={this._indoorRenderer.highlightStep.bind(this._indoorRenderer)}
                resetDirections={(this._indoorRenderer as any)._directionsRenderer.resetDirections
                    .bind((this._indoorRenderer as any)._directionsRenderer)}
                closeCb={this._closeCb}
                setUserLocation={this._indoorRenderer.setUserLocation.bind(this._indoorRenderer)}
                notifyUserDeviated={this._indoorRenderer.notifyUserDeviated.bind(this._indoorRenderer)}
                notifyProximityToDest={(this._indoorRenderer as any).notifyProximityToDest.bind(this._indoorRenderer)}
                selectedWaypoints={this._selectedWaypoints}
                selectedDestination = {this._selectedDestination}
            />,
            this._container
        );
    }

}
